import { API_URL } from "config";
import Http from "util/https";

/**
 * エラーレポートを削除
 */
export default async function deleteWeeklyErrorCsv(): Promise<void> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/weekly/csv/operation?operation=3`;
  const res = await http.get(url, {});
  console.log(res);
}